<template>
  <li
    @click="passMethod('click')"
    class="ocean-ui-list-item"
    :class="[classes, pointClass]"
  >
    <Icon
      :type="beforeIconType"
      class="ocean-ui-list-item-before-icon icon"
      v-if="assignedBeforeIcon"
      :active="active"
      :style="beforeIconStyles"
    ></Icon>
    <slot></slot>
    <Icon
      :type="afterIconType"
      class="ocean-ui-list-item-after-icon icon"
      :class="$platformClass"
      v-if="assignedAfterIcon"
      :active="active"
      :style="afterIconStyles"
    ></Icon>
  </li>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
import iconSettingMixins from '../../mixins/iconSetting';

export default {
  mixins: [themeMixins, iconSettingMixins],
  props: ['active'],
};
</script>

<style scoped lang="scss">
@import '../../../assets/scss/platform-base.scss';
.ocean-ui-list-item {
  display: block;
  width: 100%;
  min-height: 80px;
  line-height: 80px;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  position: relative;
  transition: all 0.2s ease;

  .icon {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
  }
  &-before-icon {
    margin-right: 10px;
    float: left;
    background-position: center center;
  }
  &-after-icon {
    float: right;
    margin-right: 30px !important;
    /*!rtl:raw:
      transform: scaleX(-1);
    */
  }
}
</style>
